import React from "react";
import { Container, Row } from "react-bootstrap";
import style from './Ourpartners.module.scss'

// Import all sponsor logos directly
import AusIMMLogoImg from './imgs/sponsors/AusIMM-Logo.png';
import CrownResortsImg from './imgs/sponsors/Crown_Resorts_Foundation-logo.jpg';
import DWLogoImg from './imgs/sponsors/DW Logo.png';
import FoundationForNationalParksImg from './imgs/sponsors/FoundationForNationalParksAndWildlife-Logo.png';
import IMBLogoImg from './imgs/sponsors/IMB-logo.png';
import ItsowelLogoImg from './imgs/sponsors/Itsowel-Logo.png';
import NSWGovLogoImg from './imgs/sponsors/NSWGov_Logo_rgb-01.png';
import OEHImg from './imgs/sponsors/OEH.png';
import AboriginalCorpImg from './imgs/sponsors/aboriginal-corp.png';
import ActHeritageImg from './imgs/sponsors/act-heritage.jpg';
import ActGovLogoImg from './imgs/sponsors/actgov-logo.png';
import AncorsLogoImg from './imgs/sponsors/ancors-logo.png';
import BhpBillitonImg from './imgs/sponsors/bhp-billiton.png';
import CreateNSWLogoImg from './imgs/sponsors/creatensw-logo.png';
import DafLogoImg from './imgs/sponsors/daf-logo.png';
import GptImg from './imgs/sponsors/gpt.png';
import IAccelerateLogoImg from './imgs/sponsors/iaccelerate-logo.jpg';
import MaterialsLogoImg from './imgs/sponsors/materials-logo.jpg';
import NationalTrustImg from './imgs/sponsors/national-trust.png';
import NfsaImg from './imgs/sponsors/nfsa.png';
import NSWJobsImg from './imgs/sponsors/nsw-jobs.png';
import NSWMusGalImg from './imgs/sponsors/nsw-mus-gal.png';
import NSWTafeImg from './imgs/sponsors/nsw-tafe.png';
import NSWTradeImg from './imgs/sponsors/nsw-trade.png';
import PackerFamilyLogoImg from './imgs/sponsors/packerfamily-logo.png';
import RotaryImg from './imgs/sponsors/rotary.png';
import SbeLogoImg from './imgs/sponsors/sbe-logo.png';
import SecLogoImg from './imgs/sponsors/sec-logo.png';
import South32LogoImg from './imgs/sponsors/south32-logo.jpg';
import UowImg from './imgs/sponsors/uow.png';
import WCityInnovationImg from './imgs/sponsors/w-city-innovation.png';

// Create sponsor arrays with imported images
const allSponsors = [
  { src: AusIMMLogoImg, alt: 'AusIMM Logo' },
  { src: CrownResortsImg, alt: 'Crown Resorts Foundation' },
  { src: DWLogoImg, alt: 'DW Logo' },
  { src: FoundationForNationalParksImg, alt: 'Foundation For National Parks And Wildlife' },
  { src: IMBLogoImg, alt: 'IMB Logo' },
  { src: ItsowelLogoImg, alt: 'Itsowel Logo' },
  { src: NSWGovLogoImg, alt: 'NSW Government Logo' },
  { src: OEHImg, alt: 'OEH' },
  { src: AboriginalCorpImg, alt: 'Aboriginal Corporation' },
  { src: ActHeritageImg, alt: 'ACT Heritage' },
  { src: ActGovLogoImg, alt: 'ACT Government Logo' },
  { src: AncorsLogoImg, alt: 'ANCORS Logo' },
  { src: BhpBillitonImg, alt: 'BHP Billiton' },
  { src: CreateNSWLogoImg, alt: 'Create NSW Logo' },
  { src: DafLogoImg, alt: 'DAF Logo' },
  { src: GptImg, alt: 'GPT' },
  { src: IAccelerateLogoImg, alt: 'iAccelerate Logo' },
  { src: MaterialsLogoImg, alt: 'Materials Logo' },
  { src: NationalTrustImg, alt: 'National Trust' },
  { src: NfsaImg, alt: 'NFSA' },
  { src: NSWJobsImg, alt: 'NSW Jobs' },
  { src: NSWMusGalImg, alt: 'NSW Museums & Galleries' },
  { src: NSWTafeImg, alt: 'NSW TAFE' },
  { src: NSWTradeImg, alt: 'NSW Trade' },
  { src: PackerFamilyLogoImg, alt: 'Packer Family Logo' },
  { src: RotaryImg, alt: 'Rotary' },
  { src: SbeLogoImg, alt: 'SBE Logo' },
  { src: SecLogoImg, alt: 'SEC Logo' },
  { src: South32LogoImg, alt: 'South32 Logo' },
  { src: UowImg, alt: 'University of Wollongong' },
  { src: WCityInnovationImg, alt: 'Wollongong City Innovation' }
];

// Split sponsors into two sets for the sliding animation
const middleIndex = Math.floor(allSponsors.length / 2);
const firstSponsorSet = allSponsors.slice(0, middleIndex);
const secondSponsorSet = allSponsors.slice(middleIndex);

function Ourpartners() {
  return (
    <div className="divOurpartners" style={{ marginTop: "5vh" }}>
      <Container>
        <Row>
          <h1 className={style.heading}>Our partners</h1>
        </Row>
        <div className={style.logoSlider}>
          <div className={style.logoWrapper1}>
            {firstSponsorSet.map((sponsor, index) => (
              <img 
                key={`first-${index}`} 
                src={sponsor.src} 
                alt={sponsor.alt}
                className={style.sponsorLogo}
              />
            ))}
          </div>
          <div className={style.logoWrapper1}>
            {firstSponsorSet.map((sponsor, index) => (
              <img 
                key={`first-duplicate-${index}`} 
                src={sponsor.src} 
                alt={sponsor.alt}
                className={style.sponsorLogo}
              />
            ))}
          </div>
        </div>
        <div className={style.logoSlider}>
          <div className={style.logoWrapper2}>
            {secondSponsorSet.map((sponsor, index) => (
              <img 
                key={`second-${index}`} 
                src={sponsor.src} 
                alt={sponsor.alt}
                className={style.sponsorLogo}
              />
            ))}
          </div>
          <div className={style.logoWrapper2}>
            {secondSponsorSet.map((sponsor, index) => (
              <img 
                key={`second-duplicate-${index}`} 
                src={sponsor.src} 
                alt={sponsor.alt}
                className={style.sponsorLogo}
              />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Ourpartners;